import React from "react";
import { Route } from "react-router-dom";
import PrivateRoute from "src/routes/PrivateRoute";
import { GroupsPage } from "../pages";

export const routes = (
  <>
    <Route
      path="/groups"
      element={
        <PrivateRoute>
          <GroupsPage />
        </PrivateRoute>
      }
    />
    <Route
      path="/group/:groupId"
      element={
        <PrivateRoute>
          <GroupsPage />
        </PrivateRoute>
      }
    />
  </>
);
